import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';
import viewAppCategories from './../viewRelatedAppCategories';
import viewRelatedAppPackages from './../viewRelatedAppPackages';

export default {
  title: 'App config Info',
  attributeName: 'appConfigInfo',
  fields: [
    {
      attributeName: 'app',
      helpText: 'App',
      type: FormInputTypes.SELECT,
      label: 'App',
      placeholder: 'Please enter to select an app',
      multiple: false,
      disabledWhenEdit:true,
      url: 'liveAppslist',
      emptyValue:true,
      childField:'config',
      default:'(Empty)', //default value to empty option
      fieldValue:'id',
      fieldName:'name',
      asyncSelect: true,
      options:[]
    },
    {
      attributeName: 'config',
      helpText: 'Select a valid config for the app selected, or set All for all the possible configs of the app',
      type: FormInputTypes.SELECT,
      label: 'Config',
      placeholder: 'Please enter to add a valid config',
      multiple: false,
      disabledWhenEdit:true,
      url: 'liveConfigslist',
      parentField:'app',
      enabledWhen:{"field":"app","notValues":['(Empty)']},
      emptyValue:true,
      childField:'appCategories',
      default:'(Empty)', //default value to empty option
      allValue:'(All)',
      fieldValue:'id',
      fieldName:'name',
      asyncSelect: true,
      options:[]
    },
    {
      attributeName:"sep1",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Content name',
      label: 'Name',
      required: true,
      helpText: 'Name of the content',
      errorText: '',
    },
    {
      attributeName: 'composeExperienceUrl',
      helpText: 'Select a valid media Url',
      type: FormInputTypes.SELECT,
      label: 'Media Url',
      placeholder: 'Please add a valid media url',
      multiple: false,
      url: 'liveComposeExperienceList',
      emptyValue:true,
      default:'(Empty)', //default value to empty option
      fieldValue:'id',
      fieldName:'url',
      asyncSelect: true,
      pageId:true,
      options:[]
    },
    // {
    //   attributeName: 'duration',
    //   type: FormInputTypes.TEXT_INPUT.TEXT,
    //   label: 'Duration',
    //   placeholder: 'Video duration...',
    //   helpText: 'Duration of the video in the format mm:ss.',
    // },
    {
      attributeName:"sep2",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'visibility',
      label: 'Visibility',
      helpText: 'Visibility of the video in the panel its listed.',
      default: 'enabled',
      type: FormInputTypes.SELECT,
      options: [
        { name: 'Enabled', value: 'enabled' },
        { name: 'Disabled', value: 'disabled' },
        { name: 'Hidden', value: 'hidden' },
      ],
    },
    {
      attributeName: 'activationEpoch',
      label: 'Activation Time',
      helpText: 'Date of the activation event for this video in clients.',
      type: FormInputTypes.DATE_TIME,
    },
    {
      attributeName:"sep3",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'appCategories',
      label: 'Categories',
      type: FormInputTypes.RELATIONSHIP,
      canEdit: true,
      canCreate: true,
      configFile: viewAppCategories,
      paramWhen:[{"field":"app","value":["","obj","appId"]},{"field":"config","value":["","obj","areaId"]}],
      default: [],
      helpText: 'Video categories joined.',
      enabledWhen:{"field":"config","notValues":['(Empty)','(All)']},
    },
    {
      attributeName: 'appPackages',
      label: 'V.T. Providers',
      type: FormInputTypes.RELATIONSHIP,
      maxElements:1,
      canEdit: true,
      canCreate: true,
      configFile: viewRelatedAppPackages,
      paramWhen:[{"field":"app","value":["","obj","appId"]},{"field":"config","value":["","obj","areaId"]}],
      enabledWhen:{"field":"config","notValues":['(Empty)']},
      default: [],
      helpText: 'This content can be blocked by a virtual ticket provider, select one or multiple providers to block it.',
    },
    {
      attributeName:"sep4",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'playerVersion',
      label: 'Player version',
      helpText: 'Player version of the video.',
      default: 'YBVR',
      type: FormInputTypes.SELECT,
      options: [
        { name: 'YBVR', value:'YBVR' },
        { name: 'AVPRO', value: 'AVPRO' },
      ],
    },
    {
      attributeName: 'geometry',
      label: 'Geometry',
      helpText: 'Signaling version of the video.',
      default: 'v2',
      type: FormInputTypes.SELECT,
      options: [
        { name: 'Autodetect', value: 'v2' },
        { name: 'Equirectangular', value: 'equirectangular' },
        { name: 'Equidome', value: 'equidome' },
        { name: 'Flat', value: 'flat' },
      ],
    },
    {
      attributeName: 'type',
      label: 'Type',
      default: 'mono',
      type: FormInputTypes.SELECT,
      helpText: 'Whether the video is mono or stereo.',
      options: [
        { name: 'Mono', value: 'mono' },
        { name: 'Stereo', value: 'stereo' },
        { name: 'Stereo LR', value: 'stereolr' },
      ],
      visibleWhen:[{"field":"geometry","notValue":"v2"}]
    },
    {
      attributeName: 'isAudioRecordingAllowed',
      helpText: 'Specifies if the content allow audio feedback.',
      label: 'Allow Audio feedback ',
      default: false,
      type: FormInputTypes.CHECKBOX,
    },
    {
      attributeName: 'isSlowMotionAllowed',
      helpText: 'Specifies if the content allow slow motion.',
      label: 'Allow Slow motion ',
      default: false,
      type: FormInputTypes.CHECKBOX,
    },
    {
      attributeName: 'isTimeShiftingAllowed',
      helpText: 'Specifies if the content allow slow motion.',
      label: 'Allow Timeshift ',
      default: false,
      type: FormInputTypes.CHECKBOX,
    },
    {
      attributeName:"sep5",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'poster',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Poster',
      helpText: 'Any valid url to a PNG poster image file.',
      placeholder: 'Video poster URL...',
      hasSelect:false,
      fileType: ['image/*'],
    },
    {
      attributeName: 'largePoster',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Large Poster',
      helpText: 'Any valid url to a PNG poster image file to use inside a side panel.',
      placeholder: 'Video large poster URL...',
      hasSelect:false,
      fileType: ['image/*'],
    },
    {
      attributeName: 'descriptionPoster',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Description Poster',
      helpText: 'URL to the poster image file that will be show in the description panel.',
      placeholder: 'Video description poster URL...',
      hasSelect:false,
      fileType: ['image/*'],
    },
    {
      attributeName: 'backgroundFlat',
      type: FormInputTypes.BACKGROUND,
      label: 'Background Flat',
      helpText: 'Background to use in the flat video geometries.',
      hasSelect:false,
      fileType: ['image/*'],
    },
    {
      attributeName: 'background180',
      type: FormInputTypes.BACKGROUND,
      label: 'Background 180',
      helpText: 'Background to use in the 180 video geometries.',
      hasSelect:false,
      fileType: ['image/*'],
    },
    {
      attributeName: 'description',
      type: FormInputTypes.TEXT_EDITOR,
      label: 'Description',
      placeholder: 'Video description...',
      helpText: 'Description of the video.',
    },
    {
      attributeName: 'producers',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Producers',
      placeholder: 'Video producers...',
      helpText: 'Producers of the video.',
    },
    {
      attributeName: 'isHighQuality',
      label: 'Is High Quality',
      helpText: 'Whether the video is in 8K quality.',
      default: false,
      type: FormInputTypes.CHECKBOX,
    },
    {
      attributeName:"sep6",
      type:FormInputTypes.SEPARATOR
    },
   
    // {
    //   attributeName: 'moveContent',
    //   type: FormInputTypes.BUTTON_FORM,
    //   mode:'button',
    //   label: 'Move content to other app/config',
    //   confirm:true,
    //   actionUrl:'liveMoveContent',
    //   // actionParams:['app','config'],need to implement this part
    //   title:"Are you sure you want to move this content to other place?",
    //   description:"You are about to move this content to other app/config",
    //   className:'ml-3 float-left',
    //   formConfig:
    //     {
    //     title: 'Destination information',
    //     attributeName: 'movingInfo',
    //     fields: [
    //       {
    //         attributeName: 'app',
    //         helpText: 'App',
    //         type: FormInputTypes.SELECT,
    //         label: 'Destination App',
    //         placeholder: 'Please enter to select an app',
    //         multiple: false,
    //         disabledWhenEdit:true,
    //         url: 'liveAppslist',
    //         emptyValue:true,
    //         childField:'configPopup',
    //         default:'(Empty)', //default value to empty option
    //         fieldValue:'id',
    //         fieldName:'name',
    //         asyncSelect: true,
    //         options:[]
    //       },
    //       {
    //         attributeName: 'configPopup',
    //         helpText: 'Select a valid config for the app selected, or set All for all the possible configs of the app',
    //         type: FormInputTypes.SELECT,
    //         label: 'Destination Config',
    //         placeholder: 'Please enter to add a valid config',
    //         multiple: false,
    //         disabledWhenEdit:true,
    //         url: 'liveConfigslist',
    //         parentField:'app',
    //         enabledWhen:{"field":"app","notValues":['(Empty)']},
    //         emptyValue:true,
    //         childField:'composeExperienceUrl',
    //         default:'(Empty)', //default value to empty option
    //         fieldValue:'id',
    //         fieldName:'name',
    //         asyncSelect: true,
    //         options:[]
    //       },
    //       {
    //         attributeName:"sep1",
    //         type:FormInputTypes.SEPARATOR
    //       },
    //       {
    //         attributeName: 'composeExperienceUrl',
    //         helpText: 'Select a valid composed experience Url',
    //         type: FormInputTypes.SELECT,
    //         label: 'Destination ComposeExperience Url',
    //         placeholder: 'Please add a valid composed experience url',
    //         multiple: false,
    //         url: 'liveComposeExperienceListByConfig',
    //         parentField:'configPopup',
    //         emptyValue:true,
    //         default:'(Empty)', //default value to empty option
    //         fieldValue:'id',
    //         fieldName:'url',
    //         asyncSelect: true,
    //         pageId:true,
    //         options:[]
    //       },
    //     ],
    //     }
    // },
   
    // {
    //   attributeName: 'expirationEpoch',
    //   label: 'Expiration Time',
    //   helpText: 'Date of the expiration event for this video.',
    //   type: FormInputTypes.DATE_TIME,
    // },
  ]
};
